var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBtnSecond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4149 5.56021H0.5L1.37873 3.96021L12.4149 3.96021V5.56021Z",
    fill: "#011627"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7815 0.720215L14.5004 4.72021L10.7815 8.72021H8.54297L12.2619 4.72021L8.54297 0.720215H10.7815Z",
    fill: "#011627"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBtnSecond);
export default __webpack_public_path__ + "static/media/arrow-btn-second.4fbfdeddbf88eceebe3a6147bdb5c738.svg";
export { ForwardRef as ReactComponent };